module.exports = __webpack_public_path__ + "static/img/ignore.05bb53aa.png";